module.exports = __webpack_public_path__ + "img/nfc-signal.91ac62de.svg";